var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("salesArea.BoxWrap.manage") } }, [
        _c(
          "div",
          { staticClass: "action-container" },
          [
            _c(
              "el-form",
              { attrs: { size: "small", inline: "", "label-position": "top" } },
              [
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SRStoreList.form.provinceCityDistrict"
                              ),
                            },
                          },
                          [
                            _c("el-cascader", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "DAStoreList.form.cascaderPlaceholder"
                                ),
                                options: _vm.regionOptions,
                                "collapse-tags": "",
                                clearable: "",
                                props: {
                                  multiple: true,
                                  checkStrictly: false,
                                  value: "value",
                                },
                              },
                              on: {
                                clear: _vm.pcdClearEvent,
                                change: _vm.pcdChangeEvent,
                              },
                              model: {
                                value: _vm.region,
                                callback: function ($$v) {
                                  _vm.region = $$v
                                },
                                expression: "region",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("salesArea.input.empNo") } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "salesArea.input.iptholder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.empNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "empNo", $$v)
                                },
                                expression: "searchVal.empNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("salesArea.input.empName") },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "salesArea.input.iptholder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.empName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "empName", $$v)
                                },
                                expression: "searchVal.empName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "header-bottom-right" }, [
          _c(
            "div",
            { staticClass: "header-bottom-right-btn" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { icon: "el-icon-search", size: "small" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("salesArea.BoxWrap.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["SYNC_DATA"] },
                        expression: "{pageName, list: ['SYNC_DATA']}",
                      },
                    ],
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.syncData },
                  },
                  [_vm._v(_vm._s(_vm.$t("salesArea.btn.syncData")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["IMPORT"] },
                        expression: "{pageName, list: ['IMPORT']}",
                      },
                    ],
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        _vm.downloadRegionExcel(
                          _vm.$t("salesArea.btn.exportRegionText")
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("salesArea.btn.exportRegion")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["IMPORT"] },
                        expression: "{pageName, list: ['IMPORT']}",
                      },
                    ],
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel(_vm.$t("salesArea.btn.exportText"))
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("salesArea.btn.export")))]
                ),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["IMPORT"] },
                        expression: "{pageName, list: ['IMPORT']}",
                      },
                    ],
                    staticClass: "excel-upload-input",
                    staticStyle: { display: "inline" },
                    attrs: {
                      action: "",
                      "auto-upload": false,
                      "show-file-list": false,
                      accept: ".xlsx, .xls, .xlsm, .csv",
                      "on-change": _vm.uploadData,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", size: "mini" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.form.file
                              ? _vm.$t("salesArea.btn.resetFile")
                              : _vm.$t("salesArea.btn.import")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.tableIndex,
                  label: _vm.$t("salesArea.table.systemPk"),
                  width: "80",
                  align: "left",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "regionName",
                  label: _vm.$t("salesArea.table.province"),
                  width: "220",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cityName",
                  label: _vm.$t("salesArea.table.city"),
                  width: "220",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "districtName",
                  label: _vm.$t("salesArea.table.district"),
                  "min-width": "220",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t("salesArea.table.empNo"),
                  "min-width": "220",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: _vm.$t("salesArea.table.empName"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "detail-model",
          attrs: {
            width: "900px",
            title: "导入结果",
            visible: _vm.isShowModel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowModel = $event
            },
          },
        },
        [
          _c("Detail", {
            attrs: { "batch-id": _vm.excelBatchId, "is-error": _vm.isError },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.downloadResultExcel(
                        _vm.$t("salesArea.btn.exportText")
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.exportResult")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.isShowModel = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            "is-show": _vm.isShowProgress,
            "dialog-status": "导入进度",
            "show-close": _vm.showClose,
            "is-hide-footer": !_vm.showClose,
            "confirm-btn-text": _vm.confirmText,
            "save-item": _vm.handleClickConfirm,
            width: "1200px",
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowProgress = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowProgress = $event
            },
          },
        },
        [
          _vm.isShowProgress
            ? _c("Progress", {
                ref: "progress",
                attrs: {
                  "show-result": _vm.showResult,
                  "file-import-process-unique-code":
                    _vm.fileImportProcessUniqueCode,
                  "show-close": _vm.showClose,
                },
                on: {
                  "update:showClose": function ($event) {
                    _vm.showClose = $event
                  },
                  "update:show-close": function ($event) {
                    _vm.showClose = $event
                  },
                  error: _vm.handleError,
                  animeSuccess: _vm.handleEnd,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }